import { capitalize, typeset } from "./typography.js";

// Souhrnná věta Skici (CR-014 §2): fráze pólů nebo názvy škál spojené podle jazyka („a“, „and“),
// první písmeno velké, tečka. Typografie se sází až na celou větu (spojka „a“ dostane
// nezlomitelnou mezeru, DES-003 §9).

/** Seznam spojený spojkou jazyka (`Intl.ListFormat`, `conjunction`). */
export function listOf(parts: readonly string[], locale: string): string {
  return new Intl.ListFormat(locale, { type: "conjunction", style: "long" }).format(parts);
}

/** Věta z frází: „Těžké pocity necháváš uvnitř, rozhoduješ hlavou a radost dáváš najevo naplno.“ */
export function summarySentence(phrases: readonly string[], locale: string): string {
  return typeset(`${capitalize(listOf(phrases, locale), locale)}.`, locale);
}

/** Nejvyšší délka podpisu k portrétu (zadání 27.8: 70 znaků, angličtina je delší). */
const CAPTION_LIMIT: Readonly<Record<string, number>> = { cs: 70, en: 80 };

/**
 * Podpis k portrétu (CR-015 §5): fráze v první osobě (nejvýš tři, v pořadí výraznosti) spojené
 * jako souhrn. Při délce nad limit se vypouští od nejméně výrazné, aspoň jedna zůstane, nic se
 * neusekává. Bez frází `null`.
 */
export function captionSentence(phrases: readonly string[], locale: string): string | null {
  if (phrases.length === 0) return null;
  const limit = CAPTION_LIMIT[locale] ?? 70;
  const sentence = (parts: readonly string[]) => `${capitalize(listOf(parts, locale), locale)}.`;
  let used = phrases.slice(0, 3);
  while (used.length > 1 && sentence(used).length > limit) used = used.slice(0, -1);
  return typeset(sentence(used), locale);
}
